import axios from 'axios';

export default axios.create({
		  baseURL:'https://quiz-app-43d12.firebaseio.com/'
})